import { gray100, gray80, orange50, white } from './colors';

export const spHeaderHeight = '48px';

export const headerHeight = '64px';

export const sideBarWidth = '240px';

export const titleMb = {
  '@media screen and (max-width:480px)': {
    marginLeft: 0,
  },
  fontSize: '22px',
  fontWeight: '400',
  marginBottom: '24px',
};

export const textMb = {
  marginBottom: '24px',
};

export const sizeBelowTenMb = (size: number): boolean => size / 1024 / 1024 > 10;

export const w100 = {
  width: '100%',
};

export const formLabelWrapper = {
  fontSize: '12px',
  marginBottom: '8px',
};

export const regularXl = {
  color: gray100,
  fontSize: '22px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularLg = {
  color: gray100,
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularLgWhite = {
  color: white,
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularMd = {
  color: gray100,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularMdWhite = {
  color: white,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularSm = {
  color: gray100,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const regularXs = {
  color: gray80,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
};

export const boldXs = {
  color: orange50,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
};

export const boldMd = {
  color: orange50,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
};

export const boldSm = {
  color: orange50,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
};

export const boldMdWhite = {
  color: white,
  fontSize: '16px',
  fontWeight: '700',
};

export const boldXxl = {
  color: gray100,
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
};

export const boldMdGray = {
  color: gray80,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
};

export const formWideMb = {
  marginBottom: '24px',
};

export const formNarrowMb = {
  marginBottom: '8px',
};

export const formExtraNarrowMb = {
  marginBottom: '0px',
};
